export * from './Hero';
export * from './LoginSignUp';
export * from './FAQ';
export * from './MeetAnchor';
export * from './Process';
export * from './SwitchModal';
export * from './Video';
